"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Formats a hex into something consumable by css
 */
function formatHex(hex) {
    return "#" + hex.toLowerCase();
}
exports.default = formatHex;
